import { sanitizeUrl } from '@braintree/sanitize-url'

/**
 * Prevent XSS attacks by sanitizing stings and URLs
 */
export default function sanitize(str: string, url = false) {
  if (url) {
    return sanitizeUrl(str)
  }

  const temp = document.createElement('div')
  temp.textContent = str
  return temp.innerHTML
}
